export default "__VITE_ASSET__3f613583__"